import Trails from "./Trails";

export default Trails;
